import _ from 'lodash';

const _FONT_SIZE_UNIT_TYPES = {
    EM: {text: 'em'},
    PERCENTAGE: {text: '%'},
    PX: {text: 'px'},
    VMAX: {text: 'vmax'},
    VMIN: {text: 'vmin'},
    VH: {text: 'vh'}
};

export const FONT_SIZE_UNIT_TYPES = _.forEach(_FONT_SIZE_UNIT_TYPES, (value, key) => value.key = key);

export const FONT_WEIGHT_TYPES = {
    100: {text: '100'},
    200: {text: '200'},
    300: {text: '300'},
    400: {text: '400 (Normal)'},
    500: {text: '500'},
    600: {text: '600'},
    700: {text: '700 (Bold)'},
    800: {text: '800'},
    900: {text: '900'}
};

export const FONT_SIZE_UNIT_TYPES_OPTIONS = Object.keys(FONT_SIZE_UNIT_TYPES)
    .map(key => ({..._FONT_SIZE_UNIT_TYPES[key], key}));

export const FONT_WEIGHT_TYPE_OPTIONS = Object.keys(FONT_WEIGHT_TYPES)
    .map(key => ({...FONT_WEIGHT_TYPES[key], key}));


// WEBPACK FOOTER //
// ./src/constants/fontSettingTypes.js